import React from "react";
import Typography from "@material-ui/core/Typography";
import Swipeable from "../../../../Fronts/Main/Swipeable";
import Grid from "@material-ui/core/Grid";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Divider from "@material-ui/core/Divider";
import { Button, TextField } from "@material-ui/core";
import CheckboxItem, { useStylesAcc } from "../CheckBoxComponent";
import { GetItemFromOptions } from "../../../../services/global-services";
import { Autocomplete } from "@material-ui/lab";
import { useTranslation } from "react-i18next";

export default function BasicPermissions(props) {
  const { onChange, object, update, sub } = props;
  const { t } = useTranslation(["forms"]);

  const formData = [
    { name: "HidePurchPrice", label: "hide-purchase-price" },
    { name: "NoRepeatItem", label: "prevent-item-name-duplicate" },
    {
      name: "show_ItemExpired_Alert",
      label: "hide-item-expiry-alerts-on-login",
    },
    {
      name: "update_price_first_stock",
      label: "update-prices-opening-balance",
    },
    {
      name: "update_price_pursh_bill",
      label: "update-prices-purchase-invoice",
    },
    {
      name: "update_price_currencies",
      label: "update-sale-price-sales-invoice",
    },
    {
      name: "is_saleprice_less_purch",
      label: "prevent-sale-price-below-purchase",
    },
    {
      name: "show_unit_on_bills",
      label: "show-sub-units-in-invoices",
    },
    { name: "costWithVat", label: "price-includes-tax" },
    {
      name: "show_price_on_bills",
      label: "show-item-price-levels-in-invoices",
    },
    { name: "usePriceBeforVat", label: "use-price-before-tax" },
    { name: "hide_item_balance", label: "hide-item-balance" },
    {
      name: "disable_type_sale_price",
      label: "disable-sale-price-type-control",
    },
  ];
  const classes = useStylesAcc();

  return (
    <div className={classes.root}>
      <Accordion expanded={true}>
        {/* <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          style={{ background: "#d9dcf078" }}
        >
          <Typography className={classes.heading}>
            {t("basic-data-settings")}
          </Typography>
        </AccordionSummary>

        <AccordionDetails className={classes.subTitle}>
          {" "}
          <Typography>{t("basic-data-settings")}</Typography>{" "}
        </AccordionDetails> */}

        <AccordionDetails>
          <Grid item container spacing={1}>
            {formData?.map((item) => {
              // console.log(object);
              return (
                <Grid xs={6}>
                  <CheckboxItem
                    value={object[item.name] ?? null}
                    name={item.name}
                    label={t(item.label)}
                    onChange={onChange}
                  />
                </Grid>
              );
            })}
          </Grid>
        </AccordionDetails>

        <Divider className={classes.divider} />

        <AccordionDetails className={classes.subTitle}>
          {" "}
          <Typography>
            {" "}
            <Button
              variant="contained"
              color="secondary"
              size="large"
              disabled={props.submitting}
              onClick={update}
            >
              {t("save-changes")}
            </Button>
          </Typography>{" "}
        </AccordionDetails>
      </Accordion>
      <Swipeable />
    </div>
  );
}
